import { render, staticRenderFns } from "./svg-customer.vue?vue&type=template&id=23861867&"
import script from "./svg-customer.vue?vue&type=script&lang=js&"
export * from "./svg-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports